import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuTrigger } from "@/components/core/actions/dropdown-menu";
import { useModal } from "@/components/core/modals/use-modal";
import CaseActivityLogModal from "@/features/case-evaluation/components/case-activity-log-modal";
import CaseComplianceHistoryModal from "@/features/case-evaluation/components/case-compliance-history-modal";
import CaseDeletionHistoryModal from "@/features/case-evaluation/components/case-deletion-history-modal";
import CaseEvaluationActivitySettingsModal from "@/features/case-evaluation/components/case-evaluation-activity-settings-modal";
import CaseNotificationHistoryModal from "@/features/case-evaluation/components/case-notification-history-modal";
import GenerateRolloModal from "@/features/case-evaluation/components/generate-rollo-modal.tsx";
import { useCaseRecordPostAsMutation } from "@/features/case-record/api/queries/case-records-query";
import type { CaseRecord } from "@/features/case-record/types/case-records";
import { IconSettings } from "@tabler/icons-react";

export default function CaseEvaluationSettings({
	data,
}: {
	data: CaseRecord;
}) {
	const caseRecordPostAsMutation = useCaseRecordPostAsMutation();
	const modal = useModal();

	return (
		<DropdownMenu modal={false}>
			<DropdownMenuTrigger asChild>
				<IconSettings stroke={1.5} size={25} className="text-primary-600 hover:text-primary-400 cursor-pointer" />
			</DropdownMenuTrigger>
			<DropdownMenuContent>
				<DropdownMenuGroup>
					<DropdownMenuItem>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">
							<button
								type="button"
								onClick={() => {
									modal.openModal({
										title: `${data.allow_post_as ? "Disallow" : "Allow"} "Post As"`,
										description: `You are ${data.allow_post_as ? "disallowing" : "allowing"} this user to post as other user. Please confirm`,
										type: "confirm",
										variant: "green",
										onConfirm: async () => {
											await caseRecordPostAsMutation.mutateAsync({
												id: data.id,
												allow_post_as: !data.allow_post_as,
											});
										},
									});
								}}
							>{`${data.allow_post_as ? "Disallow" : "Allow"} "Post As Admin"`}</button>
						</div>
					</DropdownMenuItem>
					<DropdownMenuItem
						onSelect={() => {
							modal.openModal({
								title: "Generate Rollo",
								showFooter: false,
								size: "md",
								component: <GenerateRolloModal caseId={data.id} />,
							});
						}}
					>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">
							<button type="button">Generate Rollo</button>
						</div>
					</DropdownMenuItem>
					<DropdownMenuItem>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">
							<button
								type="button"
								onClick={() => {
									modal.openModal({
										title: "Lock/Unlock Activity",
										description: "lock this activity.",
										showFooter: false,
										size: "lg",
										component: <CaseEvaluationActivitySettingsModal caseId={data.id} />,
									});
								}}
							>
								Lock/Unlock Activity
							</button>
						</div>
					</DropdownMenuItem>
					<DropdownMenuItem>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">
							<button
								type="button"
								onClick={() => {
									modal.openModal({
										title: "Compliance History",
										// description: "show compliance history.",
										showFooter: false,
										size: "lg",
										component: <CaseComplianceHistoryModal caseId={data.id} />,
									});
								}}
							>
								Compliance History
							</button>
						</div>
					</DropdownMenuItem>
					<DropdownMenuItem
						onSelect={() => {
							modal.openModal({
								title: "Notification History",
								showFooter: false,
								size: "lg",
								component: <CaseNotificationHistoryModal key={`modal-${data.id}-notification`} caseId={data.id} />,
							});
						}}
					>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">Notification History</div>
					</DropdownMenuItem>
					<DropdownMenuItem
						onSelect={() => {
							modal.openModal({
								title: "Delete History",
								showFooter: false,
								size: "lg",
								component: <CaseDeletionHistoryModal key={`modal-${data.id}-deletion`} caseId={data.id} />,
							});
						}}
					>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">Delete History</div>
					</DropdownMenuItem>
					<DropdownMenuItem>
						<div className="flex flex-row items-center w-full py-1 px-2 gap-2">
							<button
								type="button"
								onClick={() => {
									modal.openModal({
										title: "Activity Logs",
										description: "activity logs.",
										showFooter: false,
										size: "xl",
										component: <CaseActivityLogModal caseId={data.id} />,
									});
								}}
							>
								Activity Logs
							</button>
						</div>
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
